// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CogForm_loadingDots__JJZIG::after {
  content: "...";
  display: inline-block;
  width: 1.5em;
  text-align: left;
  animation: CogForm_dots__pwMBu 1.5s infinite;
}

@keyframes CogForm_dots__pwMBu {
  0% {
    content: "";
  }
  33% {
    content: ".";
  }
  66% {
    content: "..";
  }
  99% {
    content: "...";
  }
}`, "",{"version":3,"sources":["webpack://./src/components/createAnadPage/forms/CogForm/CogForm.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,4CAAA;AACF;;AAEA;EACE;IAAK,WAAA;EAEL;EADA;IAAM,YAAA;EAIN;EAHA;IAAM,aAAA;EAMN;EALA;IAAM,cAAA;EAQN;AACF","sourcesContent":[".loadingDots::after {\n  content: '...';\n  display: inline-block;\n  width: 1.5em;\n  text-align: left;\n  animation: dots 1.5s infinite;\n}\n\n@keyframes dots {\n  0% { content: ''; }\n  33% { content: '.'; }\n  66% { content: '..'; }\n  99% { content: '...'; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingDots": `CogForm_loadingDots__JJZIG`,
	"dots": `CogForm_dots__pwMBu`
};
export default ___CSS_LOADER_EXPORT___;
